export const version = 'berater-v1.19.0-SNAPSHOT-df48f9fd188bfba647a980a91f823cb5aea97974';